import toolData from './toolData';
import settings from './settings';
import appState from './appState';

export default { toolData, settings, appState };
